import React from 'react';
import { Lock } from 'lucide-react';
import { useUpgradePrompt } from '../../context/UpgradePromptContext';
import { FEATURE_GATES } from '../../config/limits';

/**
 * Shown on the Portfolio Value chart and Asset Allocation when a Free user has
 * picked a wallet in the Holdings filter. Those two cards keep showing the whole
 * portfolio (the per-wallet view is Plus), and this says so rather than leaving
 * them silently out of step with the table beneath.
 */
export function WalletViewLock({ walletLabel }: { walletLabel: string }) {
  const { open } = useUpgradePrompt();
  return (
    <button
      type="button"
      onClick={() => open(FEATURE_GATES.walletView)}
      title={`Showing all portfolios. The ${walletLabel} view is on Plus.`}
      className="inline-flex items-center gap-1 max-w-[9rem] px-2 py-1 rounded-lg text-[11px] font-semibold text-slate-400 border border-slate-700 hover:text-slate-100 hover:border-slate-500 transition-colors"
    >
      <Lock className="w-3 h-3 flex-shrink-0" />
      <span className="truncate">{walletLabel} on Plus</span>
    </button>
  );
}
